import { NgModule } from '@angular/core';
import { RedirectComponent } from './redirect.component';

@NgModule({
  declarations: [
    RedirectComponent,
  ],
  exports: [
    RedirectComponent,
  ],
})
export class RedirectModule {}



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/pages/redirect/redirect.module.ts